import React from "react";
import lodash from "lodash";

import { useCheckLogin, useCheckPageAccess } from "@src/hooks/index";
import { PROJECT_NAME } from "@src/helpers/constants";
import { Navigate } from "react-router-dom";

export default function MyRoute({
  name,
  authenticate,
  children,
  accessKey,
}: {
  name: string;
  authenticate: boolean;
  children: React.ReactNode;
  accessKey?: string | undefined;
}) {
  if (name) {
    let pageName = lodash.startCase(lodash.camelCase(name));
    document.title = pageName + " | " + PROJECT_NAME;
  } else document.title = PROJECT_NAME;

  const isAuthenticated = useCheckLogin();
  const isPageAccess = useCheckPageAccess(accessKey || "");
  // return children;

  if (authenticate) {
    if (accessKey && isAuthenticated && isPageAccess) {
      return children;
    } else {
      return <Navigate to="/not-allowed" />;
    }
  } else {
    return children;
  }
}
